import { Box, Skeleton, keyframes } from '@mui/material';
import PropTypes from 'prop-types';

const pulse = keyframes`
  0%, 100% { opacity: 0.45; }
  50% { opacity: 1; }
`;

function DashboardMetricSkeleton({ index = 0, accent = '#F4C24A' }) {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        minHeight: { xs: 140, sm: 160, lg: 'calc((100vh - 220px) / 2 - 14px)' },
        borderRadius: '24px',
        p: { xs: 2.5, md: 3, lg: 3.5 },
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: { xs: 2, md: 3 },
        boxSizing: 'border-box',
        background: `linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.5) 0%,
          rgba(255, 255, 255, 0.25) 100%
        )`,
        backdropFilter: 'blur(18px) saturate(180%)',
        WebkitBackdropFilter: 'blur(18px) saturate(180%)',
        border: '1px solid rgba(255, 255, 255, 0.5)',
        boxShadow:
          '0 8px 24px rgba(31, 41, 51, 0.06), inset 0 1px 0 rgba(255,255,255,0.7)',
        animation: `${pulse} 1.6s ease-in-out infinite`,
        animationDelay: `${index * 0.1}s`,
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          width: 4,
          height: '100%',
          background: accent,
          borderRadius: '24px 0 0 24px',
          opacity: 0.4
        },
        position: 'relative'
      }}
    >
      <Skeleton
        variant="rounded"
        width={64}
        height={64}
        sx={{
          borderRadius: '18px',
          bgcolor: 'rgba(255,255,255,0.4)'
        }}
      />
      <Box sx={{ flex: 1, width: '100%' }}>
        <Skeleton
          variant="text"
          width="50%"
          height={52}
          sx={{ mb: 1.5, bgcolor: 'rgba(255,255,255,0.35)' }}
        />
        <Skeleton
          variant="text"
          width="75%"
          height={24}
          sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}
        />
      </Box>
    </Box>
  );
}

DashboardMetricSkeleton.propTypes = {
  index: PropTypes.number,
  accent: PropTypes.string
};

export default DashboardMetricSkeleton;
